import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateActivityForModal as CreateActivityForModalMutation,
    CreateActivityForModalVariables as CreateActivityForModalVariables,
    ActivityCreateInput,
} from 'nutshell-graphql-types';

import CREATE_ACTIVITY_FOR_MODAL from '../mutations/create-activity-for-modal.graphql';

export const useCreateActivityForModal = (): {
    createActivityForModal: (arg1: ActivityCreateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [createActivityForModal, {loading, error}] = useMutation<
        CreateActivityForModalMutation,
        CreateActivityForModalVariables
    >(CREATE_ACTIVITY_FOR_MODAL);

    return {
        createActivityForModal: (input: ActivityCreateInput) =>
            createActivityForModal({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
